import { render, staticRenderFns } from "./folders-vessels-option-vessel-detail.vue?vue&type=template&id=be73dad2&scoped=true"
import script from "./folders-vessels-option-vessel-detail.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option-vessel-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be73dad2",
  null
  
)

export default component.exports